import { useEffect } from 'react';
import { isEqual } from 'lodash';
import { FileList } from 'components/common/types';
import { RouteFrameCode } from 'components/common/types/Deal.types';
import { FrameList } from 'components/pages/AvailabilityReport/AddFilter/AddFilter.types';

export const useSyncLocalStateWithProps = (
  selectedFrameList: FrameList | undefined,
  setSelectedRouteFrameCodes: (codes: RouteFrameCode[]) => void,
  setUploadedFrameLists: (files: FileList[]) => void,
  selectedRouteFrameCodes: RouteFrameCode[],
  uploadedFrameLists: FileList[],
): void => {
  useEffect(() => {
    if (!selectedFrameList) return;

    if (!isEqual(selectedFrameList.routeFrameCodes, selectedRouteFrameCodes)) {
      setSelectedRouteFrameCodes(selectedFrameList.routeFrameCodes || []);
    }
    if (!isEqual(selectedFrameList.uploadedFrameLists, uploadedFrameLists)) {
      setUploadedFrameLists(selectedFrameList.uploadedFrameLists || []);
    }
  }, [selectedFrameList]);
};

export const useUpdateParentOnChange = (
  isOpen: boolean,
  selectedRouteFrameCodes: RouteFrameCode[],
  uploadedFrameLists: FileList[],
  changeFilters: (filters: { frameList: FrameList }) => void,
): void => {
  useEffect(() => {
    if (isOpen) {
      changeFilters({
        frameList: {
          routeFrameCodes: selectedRouteFrameCodes,
          uploadedFrameLists,
        },
      });
    }
  }, [selectedRouteFrameCodes, uploadedFrameLists, isOpen]);
};
